import { createBrowserRouter } from "react-router-dom";

// layout
import NotFound from "@/features/NotFound";
import AuthLayout from "@/shared/layouts/AuthLayout";
import NotAuthLayout from "@/shared/layouts/NotAuthLayout";
import RouterErrorBoundary from "@/shared/layouts/RouterErrorBoundary";

// Import route configurations
import { authRoutes } from "./authRoutes";
import { commonRoutes } from "./commonRoutes";
import { dashboardRoutes } from "./dashboardRoutes";
import { donationsRoutes } from "./donationsRoutes";
import { reportsRoutes } from "./reportsRoutes";
import { donorsRoutes } from "./donorsRoutes";
import { giftsRoutes } from "./giftsRoutes";
import { marketingRoutes } from "./marketingRoutes";
import { messagesRoutes } from "./messagesRoutes";
import { operationsRoutes } from "./operationsRoutes";
import { websiteRoutes } from "./websiteRoutes";
import { settingsRoutes } from "./settingsRoutes";

export const router = createBrowserRouter([
  {
    // Authenticated routes
    path: "/",
    element: <AuthLayout />,
    errorElement: <RouterErrorBoundary />,
    children: [
      ...dashboardRoutes,
      ...donationsRoutes,
      ...reportsRoutes,
      ...donorsRoutes,
      ...giftsRoutes,
      ...marketingRoutes,
      ...messagesRoutes,
      ...operationsRoutes,
      ...websiteRoutes,
      ...settingsRoutes,
      ...commonRoutes,
    ],
  },
  {
    // Non-authenticated routes
    path: "/",
    element: <NotAuthLayout />,
    errorElement: <RouterErrorBoundary />,
    children: [...authRoutes],
  },

  {
    // Catch-all route for 404 Not Found
    path: "*",
    element: <NotFound />,
  },
]);
